export const GET_LESSONS = [
  {
    id: 1,
    title: "Om artros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/1.whatisOA-74328074295eb74cb56b582b5dbf6a0015ed002b91a058e6fe2c36425eeace98.svg",
    parts_count: 5,
    target_joints: ["hip", "knee"],
  },
  {
    id: 2,
    title: "Riskfaktorer för artros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2.riskfactorswithOA-f967b4f2565b217578edb9eedf81e80fa5abec3dd3e20ea1605b650735aabd8f.svg",
    parts_count: 4,
    target_joints: ["hip", "knee"],
  },
  {
    id: 3,
    title: "Hantera dina symtom",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 4,
    target_joints: ["hip", "knee"],
  },
  {
    id: 4,
    title: "Vägen till din diagnos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 5,
    title: "Träning & kroppsvikt",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/5.trainingandweightloss-5a148e7ef742481638bc3c93ad174301ac5f5e3b43020544c64be3f9ee90ad98.svg",
    parts_count: 5,
    target_joints: ["hip", "knee"],
  },
  {
    id: 6,
    title: "Att hantera smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_6-3b02504470146a82ea041ece81f8e022e447a917196e69f2ba55cfe5d8dbe32f.svg",
    parts_count: 3,
    target_joints: ["hip", "knee", "hand"],
  },
  {
    id: 7,
    title: "Träning & hälsa",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7.trainingandtheirhealtheffects-08181c2e88d3f56d65986221a61802e69992afe6456ba3e10c99180d14d85aba.svg",
    parts_count: 4,
    target_joints: ["hip", "knee"],
  },
  {
    id: 8,
    title: "Icke-invasiva behandlingar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/8.pillstrainingandunusaltreatments-6769136321248fbf1ecc264f97d4d5980ca3ff9c430ae9e80270a07b59f552bf.svg",
    parts_count: 4,
    target_joints: ["hip", "knee"],
  },
  {
    id: 9,
    title: "Invasiva behandlingar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/9.acupunctureinjectionsandsurgery-ca4d26ed0f684b0b9a0a3d80dfbe281754d979e2591c29127f9e8a25d7f37094.svg",
    parts_count: 5,
    target_joints: ["hip", "knee"],
  },
  {
    id: 10,
    title: "Om motivation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/10.staying motivated-02af1fca40f8f14bc1390fe20fde7500d35f9ca95200ce3688e602f591ef2406.svg",
    parts_count: 2,
    target_joints: ["hip", "knee", "lower_back", "shoulder", "neck", "foot", "elbow", "hand"],
  },
  {
    id: 11,
    title: "Om viktkontroll",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/11.weightlossandoa-66594230e929b0769761038b446a7badbebdd275a608b96f75cffd8f61480184.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 12,
    title: "Vikten av sömn",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/12.theimportanceofsleep-87702d70c6b262e71c9ec6a0dcd72c851c306aa562d2607be2910f40110d3089.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 13,
    title: "Styrke- & konditionsträning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/13.createyourowntrainingprogram-3a9107db6b6daa83f5f03386cb536433e4035ce7a2bf09b462bdad73dfd95994.svg",
    parts_count: 3,
    target_joints: ["hip", "knee", "lower_back"],
  },
  {
    id: 14,
    title: "Hälsosam kost",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/14.eathealthywithoutthinkingaboutit-0668cfeb7a9182330dc2475ef864163e7793e37c912f83af784e6694c5b6ee1c.svg",
    parts_count: 3,
    target_joints: ["hip", "knee", "lower_back"],
  },
  {
    id: 15,
    title: "Artros & jobb",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/15.oatratmentandafulltimejob-92a4d4e02fd503a2b8b6f2d31f26825ed05ae0fa184893e9c955bc8600b5dffc.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 16,
    title: "Protesoperation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/17.prostheticsurgeryprosandcons-b49d2960656a0fe42aefc9bb207a30491aeb4a8b903303d09c36b10370872313.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 17,
    title: "Att äta hälsosamt enligt vetenskapen",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/19.healthyeatingaccordingtoscience-94712956a9c2fa80768cdc5efc12c85bf316fffe30b00be58b598b2ba6cb1734.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 18,
    title: "Mer om operation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 19,
    title: "Styrka, rörlighet & kondition",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/21.aboutstrenghtaerobicfitnessandmobility-aa3991cc87733ae07cf8a9427af1f350f5bb0df884786d9b16398ac800e16ab4.svg",
    parts_count: 3,
    target_joints: ["hip", "knee"],
  },
  {
    id: 20,
    title: "Att resa med artros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/22.travelingwithoa-0c0a9452f9442263418b3b2ae5d3d854532d87121a50d0db9b6c11c75abfd4ef.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 21,
    title: "Träning innan operation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/23.trainingbeforesurgery-6a9daa59eca13849017b95de395be592c0d685df92df577ad41e97554b9b991f.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 22,
    title: "Att hantera motgångar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/24.setbacksarecompletelynormal-dbfa89eb52f1a88d13f61f273d6c416fa5d5469fea10e73dd20c3f4f6e5cacb3.svg",
    parts_count: 2,
    target_joints: ["hip", "knee", "lower_back"],
  },
  {
    id: 23,
    title: "Naturläkemedel & receptfria preparat",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/25.naturalremediesandothernonprescriptiondrugs-f385c9b584a18f52f51f26dbf477b53190456b556d3fe32240458c87e4db9841.svg",
    parts_count: 2,
    target_joints: ["hip", "knee"],
  },
  {
    id: 24,
    title: "Ta hjälp av din hund",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/26.letyourdoghelpyou-66af35cc47b2a3ec74c4bc3471808afb4e398703e5e2909466977e093431e306.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 25,
    title: "Roligare träning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/27.howtomaketrtainingmorefun-1c4edd32d94517b6afad5b8b6923a1d56d024e94fb053596ddd8dbb91d677ef6.svg",
    parts_count: 1,
    target_joints: ["hip", "knee", "lower_back"],
  },
  {
    id: 26,
    title: "Framsteg i viktminskning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/28.measuringweightlossprogress-3fdae5281fab33b07a93247538b88db9b3908e05ddd50d0cd03e22c20918e6fd.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 27,
    title: "Om ländryggssmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp01.aboutbackpain-fcbee4881417b91e3634c8f791c10f4102168f66bc816e3d8dbd231c25be00e3.svg",
    parts_count: 3,
    target_joints: ["lower_back"],
  },
  {
    id: 28,
    title: "Vägen till en diagnos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp02.gettingadiagnosis-0d35be2610be620ec1694c3016b70b228fa9296a0880a248eafc5fec35df40b4.svg",
    parts_count: 2,
    target_joints: ["lower_back"],
  },
  {
    id: 29,
    title: "Ryggens anatomi ",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp03.atonomiofthespine-454427f67e4ba10b8b12c17c3c41eac36bf4d2f7ceedf725a2cad8d8b742f521.svg",
    parts_count: 4,
    target_joints: ["lower_back"],
  },
  {
    id: 30,
    title: "Vanliga orsaker till ryggsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 4,
    target_joints: ["lower_back"],
  },
  {
    id: 31,
    title: "Mindre vanliga orsaker till ryggsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
    parts_count: 2,
    target_joints: ["lower_back"],
  },
  {
    id: 32,
    title: "Om smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp06.aboutpain-a478458b86496bd61df3666f294d2579751763417bb8186e4710a7e3b9bb49f6.svg",
    parts_count: 3,
    target_joints: ["lower_back"],
  },
  {
    id: 33,
    title: "Smärthantering",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp07.painmanagement-6c9985e6694d8947b16e47bec1e7bb992aa8f9c131f0d1fce14bd017306a3561.svg",
    parts_count: 3,
    target_joints: ["lower_back"],
  },
  {
    id: 34,
    title: "Rörelserädsla",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp08.fearofmovement-6091094bdaf04cf31850a6523fce6a9a8741cefd852c60ec16b1df1add4eee5b.svg",
    parts_count: 2,
    target_joints: ["lower_back"],
  },
  {
    id: 35,
    title: "Ergonomi ",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp09.ergonomics-bceff7e0b2cc8a65e9e5be1feddcf3ec091c6e5087c5a1b88637aa054f2a7c9c.svg",
    parts_count: 4,
    target_joints: ["lower_back"],
  },
  {
    id: 36,
    title: "Fysisk aktivitet & ryggsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
    parts_count: 2,
    target_joints: ["lower_back"],
  },
  {
    id: 37,
    title: "Träning & ryggbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp11.exercisebackpain-1344f8a0d30e4a5e438e8c81f742c409a063563cc2af0ba4dbdd2eb05cff7ed7.svg",
    parts_count: 3,
    target_joints: ["lower_back"],
  },
  {
    id: 38,
    title: "Andra behandlingar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp12.othertreatmentoptions-9501c00d9a4e99a2911b9a377beee27f638cc12f324072de62fd6557fc53b3a1.svg",
    parts_count: 3,
    target_joints: ["lower_back"],
  },
  {
    id: 39,
    title: "Om ryggoperation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp13.aboutlowbacksurgery-de7aaad154d83ed59dfcc38119c1990ee7f85fb62fdb85d1f7b3b0de689c4a0b.svg",
    parts_count: 1,
    target_joints: ["lower_back"],
  },
  {
    id: 40,
    title: "Myter & sanningar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp14.mythsfacts-95c16b9c9380d18e846e88bd4e3ab99c6228102cd639d412724c9a9dc1a9f0ef.svg",
    parts_count: 5,
    target_joints: ["lower_back"],
  },
  {
    id: 41,
    title: "Sömn & smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp15.sleeppain-a42f41334523ac2497bed7d91e0f121d471d19843cd85c8aa2e6e7c1406117aa.svg",
    parts_count: 1,
    target_joints: ["lower_back"],
  },
  {
    id: 42,
    title: "Innan du börjar träna",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 43,
    title: "Handträning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa002-c927b798347f8915f8494104596e91d6453e50823cbe180cf80926d8bde149c0.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 44,
    title: "Om handartros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa01-36a11081241b76d63bd2dca1097fb12698326d89635b8a729b43eb1172dbd66b.svg",
    parts_count: 3,
    target_joints: ["hand"],
  },
  {
    id: 45,
    title: "Att få diagnos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa02-9a54f1f8270e4729e8f424af521c6baaadbbd7259fd376a6823820ccd3d297c5.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 46,
    title: "Orsaker till handartros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa03-9a6c09dbc80eeb4b8c33517bbea682ab15f12adb2467b0b7ce148526ce6e045a.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 47,
    title: "Vardagsverktyg",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa04-6c37d4e68c750146141d762a103507bf09da176ef9573214d23cc8caf55eddc5.svg",
    parts_count: 2,
    target_joints: ["hand"],
  },
  {
    id: 48,
    title: "Läkemedel vid handartros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa05-5fc50a1425522e96e430c5058150af520ed1f7ffeeba476f22ede414ccf6bc7d.svg",
    parts_count: 2,
    target_joints: ["hand"],
  },
  {
    id: 49,
    title: "Tips: Svåra förpackningar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa06-5eda89e73ab1fa65aea264f9cd60d750a0e4f2b499b6ec4ce67530afa68571e7.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 50,
    title: "Smärta vid handartros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa07-d94c49389adc2c4e9ba125fb64c6f36005ca66c09bfd5f302414a2a322bf5d4c.svg",
    parts_count: 2,
    target_joints: ["hand"],
  },
  {
    id: 51,
    title: "Tips: Köksredskap",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa08-270214065e4c78c5724f6349f412fc21ecc895ba9683b30e5285c6707e54c2ff.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 52,
    title: "Tips: Städning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa09-b73d52b7954285286daf9b74cb107298208cd932750f9b72ba61849090d8e437.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 53,
    title: "Tum- & handledsortoser",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa10-8ce85c49c7da9e3d38052c0fe9d141047673f6fb9bd965fd14258a1161f6f793.svg",
    parts_count: 3,
    target_joints: ["hand"],
  },
  {
    id: 54,
    title: "Tips: Varje dag",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa11-1062b044e6871a8d166b38e38889e2148c82e3c8ece39f887170357531db3c83.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 55,
    title: "Om handkirurgi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa12-75cba00eef5e8b851096c103f43613a65794142dc459ecf180709039e2443df5.svg",
    parts_count: 2,
    target_joints: ["hand"],
  },
  {
    id: 56,
    title: "Tips: I trädgården",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa13-fe89fe215e68d6320598b73d37a25aabff211e6893dcc7d48af577c42b308049.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 57,
    title: "Sömn som smärtlindring",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa14-2d99206a97a2061cc446b5a5e19a973d222738af29a80f7c1febeaadb3212dde.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 58,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2717761c10978ff83fee71d51eba618fdbd2b900ea06b63cde58d87c6524458d.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 59,
    title: "Om axelsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/15e04b8ace11d807cf2317fb65036690642a897a0345981da29ade2ae195d7a5.svg",
    parts_count: 3,
    target_joints: ["shoulder"],
  },
  {
    id: 60,
    title: "Diagnos av axelsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/f1223f4a573a1fb637f18907f18b3503104fa314d9c91e8ce043533362c1a10e.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 61,
    title: "Riskfaktorer för axelsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/968f035e8e1ad88f37f29f6b08d15bb968d8ef062d3e1990454a809b62539d76.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 62,
    title: "Axelns anatomi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/159acc0a4920170a8c93975ed66fc8f5a4c30e5e2f1d0b08ef57394220299494.svg",
    parts_count: 4,
    target_joints: ["shoulder"],
  },
  {
    id: 63,
    title: "Orsaker till axelsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7931384064fd3187ab7a9ad45598af8b8df1b15592359a452eda609eba61ca03.svg",
    parts_count: 5,
    target_joints: ["shoulder"],
  },
  {
    id: 64,
    title: "Bra att komma ihåg",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2496c574630e94a0f56dedf53bc2bfcbf9c7af516b2fe552abbefb1a41494e93.svg",
    parts_count: 1,
    target_joints: ["shoulder"],
  },
  {
    id: 65,
    title: "Om smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7aef948efd7eb2a1649b94f60efe77cf4af5ce2c5388157f4ae8db9e9c46b13e.svg",
    parts_count: 3,
    target_joints: ["shoulder", "neck"],
  },
  {
    id: 66,
    title: "Att hantera smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c59bd67c53ad7e1c319baa9dd7e6bdcdb7f036bd1800a608df87717d8102876b.svg",
    parts_count: 3,
    target_joints: ["shoulder", "neck"],
  },
  {
    id: 67,
    title: "Några praktiska tips",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/d8d989b4501559581d24d544635354b2d03478dccf7664f9b2fa00c7254303ce.svg",
    parts_count: 1,
    target_joints: ["shoulder"],
  },
  {
    id: 68,
    title: "Fördelar med fysisk aktivitet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/ffa035e94169b10d79351110d869c8cd9397640e36a0e252d6dee8c05d1640e1.svg",
    parts_count: 4,
    target_joints: ["shoulder"],
  },
  {
    id: 69,
    title: "Rörelserädsla",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/65131ff2335e69071b87e9ac2ea00ba9499d410a5ba794102366b7c740f09b4a.svg",
    parts_count: 2,
    target_joints: ["shoulder", "neck", "foot", "hip", "hand"],
  },
  {
    id: 70,
    title: "Jobbrelaterade faktorer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/abecc8316c00aca264e3e2d5a605a6701002e7f78a074f8dc14578374d3efa21.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 71,
    title: "Undvik axelsmärta på jobbet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/9a0288b5a1faa35a145729e6f1f98b898a187a1f8975788f13405f5dc52e0f37.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 72,
    title: "Fysisk aktivitet eller träning?",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/f0c9be61dda7c4341ec06dd75a88b792b35f9863ac6332ee01d628ba65588883.svg",
    parts_count: 3,
    target_joints: ["shoulder"],
  },
  {
    id: 73,
    title: "Smärta & Sömn",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4ca8fd1c17c89d13d505df79b5508f952dfe94d3e71e5cde50a8faab2b0f341d.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 74,
    title: "Andra behandlingar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/6c94fee12f71960cc04a5ed1b8d77dfb5ca667deb4585153df6e78cecc78813f.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 75,
    title: "Om axeloperationer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/22fb4af3912341a53255433bd1978104d8abd465dbb01d0d027106a42dffae9d.svg",
    parts_count: 2,
    target_joints: ["shoulder"],
  },
  {
    id: 76,
    title: "Myter & sanningar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c1aae87a7a9a141d0ae5cd89fd9357148eb687168d02059ed72f8b03aff411c1.svg",
    parts_count: 4,
    target_joints: ["shoulder"],
  },
  {
    id: 77,
    title: "Innan du börjar träna",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/f1a5e668494587ee4b47f86cd6cbe78daf7970de7cf227263cb4cba842984dda.svg",
    parts_count: 1,
    target_joints: ["neck"],
  },
  {
    id: 78,
    title: "Om nacksmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/082c6b4a17939c1c513ca15feccbf45dcc3cf20ec3a085101cfcaa08bbae328b.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 79,
    title: "Diagnos av nacksmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/37ae154f23a514247eff9454a9225b0ca141f9b716dd4b1576675820860a0f6f.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 80,
    title: "Riskfaktorer för nacksmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/bf4475d3b318063e74e926c87a27ae2786088803c488f586909ad17093ad8751.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 81,
    title: "Nackens anatomi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/f75d3bebb7b14d517ccf2ce8f2a4e358f9ba5431ba691dcc5fc10e3d0a61bd5b.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 82,
    title: "Vanliga orsaker till nacksmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/b4acf57b2aab32b6df1c5a7447e6fa6a7e44f56176fe1798deb5c1edb6ecf6c9.svg",
    parts_count: 3,
    target_joints: ["neck"],
  },
  {
    id: 83,
    title: "Mindre vanliga orsaker",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c57f3879c959192ac53d1f6621a4416701a67c21de8ebdfca582455c5e2c2952.svg",
    parts_count: 3,
    target_joints: ["neck"],
  },
  {
    id: 84,
    title: "Träning för nackbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/154f4354f5acf6485f270724989d72028765c8317fe1ea2d23a00f56a0768dd7.svg",
    parts_count: 3,
    target_joints: ["neck"],
  },
  {
    id: 85,
    title: "Sömn & nackbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/59c4cade42c29a9c2d42d3ed13dd0a4d483502ad1438224e849d8429a32bcaa5.svg",
    parts_count: 1,
    target_joints: ["neck"],
  },
  {
    id: 86,
    title: "Fortfarande bra att veta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/75662d5350f6fbd2da188f3c9aa73f51c838e12e6f34ad032e519dfaa47dcaea.svg",
    parts_count: 1,
    target_joints: ["neck"],
  },
  {
    id: 87,
    title: "Om nackoperationer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/a82956b54794a596059bc6aab220c68fc3d2facd42ce7f608b09cf0ea0833803.svg",
    parts_count: 1,
    target_joints: ["neck"],
  },
  {
    id: 88,
    title: "Jobbrelaterade faktorer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/45325a1a22bc24b2c1b5d74ad05c178d6fe451e0f93b59d282e9cfcb95067fde.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 89,
    title: "Att undvika nacksmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/51a7616d019e736b049dc3ad411ed0ab5b30fbfbe7516f4a47ffd17cf3dfb5da.svg",
    parts_count: 2,
    target_joints: ["neck"],
  },
  {
    id: 90,
    title: "Fysisk aktivitet & nackbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/dd5aa0ca606c69903043eacce2c1c46e323c2cdc8932d590c8c44fa285c511d3.svg",
    parts_count: 3,
    target_joints: ["neck"],
  },
  {
    id: 91,
    title: "Andra behandlingar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c9de4dee601b06233e04054950f475c2a8b8466acb6a2ce26023d733e9d212d9.svg",
    parts_count: 3,
    target_joints: ["neck"],
  },
  {
    id: 92,
    title: "Kärnbudskap",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2e32f2297f0ca79477739fe6ea453a1572ee7c97afbd4b0cb5fb646a89ac6be3.svg",
    parts_count: 5,
    target_joints: ["neck"],
  },
  {
    id: 93,
    title: "Sömn som smärtlindring",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/1f11290be8cad90f857d57c7451fb0d57e27bb308375c1b6c73346ec38de0499.svg",
    parts_count: 2,
    target_joints: ["neck", "foot", "elbow", "hip", "hand"],
  },
  {
    id: 94,
    title: "Fördelar med fysisk aktivitet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/f54edac51513ae74c57886389fa9e3a63fc8127d9bfed72259350cd1b9ab40a1.svg",
    parts_count: 3,
    target_joints: ["neck", "foot", "elbow", "hip", "knee", "hand"],
  },
  {
    id: 95,
    title: "Bra att veta innan du börjar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["fall_prevention"],
  },
  {
    id: 96,
    title: "Mer om din behandling och säkerhet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 2,
    target_joints: ["fall_prevention"],
  },
  {
    id: 97,
    title: "Minska risken för fall med träning och kunskap",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 3,
    target_joints: ["fall_prevention"],
  },
  {
    id: 98,
    title: "Om balans och balansträning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7.trainingandtheirhealtheffects-08181c2e88d3f56d65986221a61802e69992afe6456ba3e10c99180d14d85aba.svg",
    parts_count: 3,
    target_joints: ["fall_prevention"],
  },
  {
    id: 99,
    title: "Sjukdomar med fallrisk",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 2,
    target_joints: ["fall_prevention"],
  },
  {
    id: 100,
    title: "När du är utomhus",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/6.everydaymeasures-25561c64e832f76f49d92cbee7774e591c180aeb8b5f3b6cb641e965ccf10c28.svg",
    parts_count: 2,
    target_joints: ["fall_prevention"],
  },
  {
    id: 101,
    title: "Styrketräning som fysisk aktivitet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/23.trainingbeforesurgery-6a9daa59eca13849017b95de395be592c0d685df92df577ad41e97554b9b991f.svg",
    parts_count: 4,
    target_joints: ["fall_prevention"],
  },
  {
    id: 102,
    title: "Mat och Näring",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/19.healthyeatingaccordingtoscience-94712956a9c2fa80768cdc5efc12c85bf316fffe30b00be58b598b2ba6cb1734.svg",
    parts_count: 3,
    target_joints: ["fall_prevention"],
  },
  {
    id: 103,
    title: "Myter och sanningar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa03-9a6c09dbc80eeb4b8c33517bbea682ab15f12adb2467b0b7ce148526ce6e045a.svg",
    parts_count: 1,
    target_joints: ["fall_prevention"],
  },
  {
    id: 104,
    title: "Bra att veta innan du börjar",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["osteoporosis"],
  },
  {
    id: 105,
    title: "Ditt behandlingsprogram",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
    parts_count: 2,
    target_joints: ["osteoporosis"],
  },
  {
    id: 106,
    title: "Se över din omgivning och minska risken för fall",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/24.setbacksarecompletelynormal-dbfa89eb52f1a88d13f61f273d6c416fa5d5469fea10e73dd20c3f4f6e5cacb3.svg",
    parts_count: 5,
    target_joints: ["osteoporosis", "fall_prevention"],
  },
  {
    id: 107,
    title: "Träning för osteoporos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/23.trainingbeforesurgery-6a9daa59eca13849017b95de395be592c0d685df92df577ad41e97554b9b991f.svg",
    parts_count: 2,
    target_joints: ["osteoporosis"],
  },
  {
    id: 108,
    title: "Balansförmåga",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7.trainingandtheirhealtheffects-08181c2e88d3f56d65986221a61802e69992afe6456ba3e10c99180d14d85aba.svg",
    parts_count: 3,
    target_joints: ["osteoporosis"],
  },
  {
    id: 109,
    title: "Balansträning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
    parts_count: 4,
    target_joints: ["osteoporosis"],
  },
  {
    id: 110,
    title: "Lite om osteoporos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
    parts_count: 1,
    target_joints: ["osteoporosis"],
  },
  {
    id: 111,
    title: "Att falla rätt och att resa sig",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 2,
    target_joints: ["osteoporosis"],
  },
  {
    id: 112,
    title: "Mer om osteoporos",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 3,
    target_joints: ["osteoporosis"],
  },
  {
    id: 113,
    title: "Riskfaktorer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 1,
    target_joints: ["osteoporosis"],
  },
  {
    id: 114,
    title: "Synen och fallrisk",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa01-8d508e8c3c97ccaa9d0886951fc98db82ab47b9371347105329604f3b5d223bb.svg",
    parts_count: 2,
    target_joints: ["osteoporosis", "fall_prevention"],
  },
  {
    id: 115,
    title: "Anatomi och benomsättning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp02.gettingadiagnosis-0d35be2610be620ec1694c3016b70b228fa9296a0880a248eafc5fec35df40b4.svg",
    parts_count: 1,
    target_joints: ["osteoporosis"],
  },
  {
    id: 116,
    title: "Benskörhetsrelaterade frakturer",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa12-75cba00eef5e8b851096c103f43613a65794142dc459ecf180709039e2443df5.svg",
    parts_count: 3,
    target_joints: ["osteoporosis"],
  },
  {
    id: 117,
    title: "Mat och Näring",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/19.healthyeatingaccordingtoscience-94712956a9c2fa80768cdc5efc12c85bf316fffe30b00be58b598b2ba6cb1734.svg",
    parts_count: 3,
    target_joints: ["osteoporosis"],
  },
  {
    id: 118,
    title: "Mer om kost",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/19.healthyeatingaccordingtoscience-94712956a9c2fa80768cdc5efc12c85bf316fffe30b00be58b598b2ba6cb1734.svg",
    parts_count: 1,
    target_joints: ["osteoporosis", "fall_prevention"],
  },
  {
    id: 128,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 129,
    title: "Om Golfarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 4,
    target_joints: ["elbow"],
  },
  {
    id: 130,
    title: "Behandling av golfarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 131,
    title: "Att tänka på vid golfarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/15.oatratmentandafulltimejob-92a4d4e02fd503a2b8b6f2d31f26825ed05ae0fa184893e9c955bc8600b5dffc.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 132,
    title: "Armbågsskydd för golfarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp06.aboutpain-a478458b86496bd61df3666f294d2579751763417bb8186e4710a7e3b9bb49f6.svg",
    parts_count: 1,
    target_joints: ["elbow"],
  },
  {
    id: 133,
    title: "Se över ditt kontor",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp09.ergonomics-bceff7e0b2cc8a65e9e5be1feddcf3ec091c6e5087c5a1b88637aa054f2a7c9c.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 134,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 135,
    title: "Om tennisarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 5,
    target_joints: ["elbow"],
  },
  {
    id: 136,
    title: "Behandling av tennisarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa03-9a6c09dbc80eeb4b8c33517bbea682ab15f12adb2467b0b7ce148526ce6e045a.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 137,
    title: "Att tänka på vid tennisarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/15.oatratmentandafulltimejob-92a4d4e02fd503a2b8b6f2d31f26825ed05ae0fa184893e9c955bc8600b5dffc.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 138,
    title: "Armbågsskydd vid tennisarmbåge",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp06.aboutpain-a478458b86496bd61df3666f294d2579751763417bb8186e4710a7e3b9bb49f6.svg",
    parts_count: 1,
    target_joints: ["elbow"],
  },
  {
    id: 139,
    title: "Se över ditt kontor",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp09.ergonomics-bceff7e0b2cc8a65e9e5be1feddcf3ec091c6e5087c5a1b88637aa054f2a7c9c.svg",
    parts_count: 2,
    target_joints: ["elbow"],
  },
  {
    id: 140,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["lower_leg"],
  },
  {
    id: 141,
    title: "Om hälsenebesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
    parts_count: 2,
    target_joints: ["lower_leg"],
  },
  {
    id: 142,
    title: "Att anpassa sin träning",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/27.howtomaketrtainingmorefun-1c4edd32d94517b6afad5b8b6923a1d56d024e94fb053596ddd8dbb91d677ef6.svg",
    parts_count: 1,
    target_joints: ["lower_leg"],
  },
  {
    id: 143,
    title: "Bra att veta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 2,
    target_joints: ["lower_leg"],
  },
  {
    id: 144,
    title: "Anatomi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2.riskfactorswithOA-f967b4f2565b217578edb9eedf81e80fa5abec3dd3e20ea1605b650735aabd8f.svg",
    parts_count: 2,
    target_joints: ["lower_leg"],
  },
  {
    id: 145,
    title: "Träning som medicin",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/27.howtomaketrtainingmorefun-1c4edd32d94517b6afad5b8b6923a1d56d024e94fb053596ddd8dbb91d677ef6.svg",
    parts_count: 3,
    target_joints: ["lower_leg"],
  },
  {
    id: 146,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 3,
    target_joints: ["hip"],
  },
  {
    id: 147,
    title: "Om höftsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 3,
    target_joints: ["hip"],
  },
  {
    id: 148,
    title: "Höftens uppbyggnad",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 1,
    target_joints: ["hip"],
  },
  {
    id: 149,
    title: "Trokanterit",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp06.aboutpain-a478458b86496bd61df3666f294d2579751763417bb8186e4710a7e3b9bb49f6.svg",
    parts_count: 3,
    target_joints: ["hip"],
  },
  {
    id: 150,
    title: "Praktiska tips",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/24.setbacksarecompletelynormal-dbfa89eb52f1a88d13f61f273d6c416fa5d5469fea10e73dd20c3f4f6e5cacb3.svg",
    parts_count: 3,
    target_joints: ["hip"],
  },
  {
    id: 151,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 152,
    title: "Om knäsmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2.riskfactorswithOA-f967b4f2565b217578edb9eedf81e80fa5abec3dd3e20ea1605b650735aabd8f.svg",
    parts_count: 3,
    target_joints: ["knee"],
  },
  {
    id: 153,
    title: "Knäts uppbyggnad",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 154,
    title: "Främre knäsmärta (patellofemoral smärta)",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 155,
    title: "Främre och bakre korsbandsskada (ACL- och PCL-skada)",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 156,
    title: "Löparknä",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/27.howtomaketrtainingmorefun-1c4edd32d94517b6afad5b8b6923a1d56d024e94fb053596ddd8dbb91d677ef6.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 157,
    title: "Hopparknä (patellar tendinopati)",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 4,
    target_joints: ["knee"],
  },
  {
    id: 158,
    title: "Meniskskada",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 159,
    title: "Knäbursit",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 1,
    target_joints: ["knee"],
  },
  {
    id: 160,
    title: "Knäskydd",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/26.letyourdoghelpyou-66af35cc47b2a3ec74c4bc3471808afb4e398703e5e2909466977e093431e306.svg",
    parts_count: 1,
    target_joints: ["knee"],
  },
  {
    id: 161,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 3,
    target_joints: ["foot"],
  },
  {
    id: 162,
    title: "Anatomi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 3,
    target_joints: ["foot"],
  },
  {
    id: 163,
    title: "Om fot och fotledsbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 8,
    target_joints: ["foot"],
  },
  {
    id: 164,
    title: "Om fot och fotledsbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 3,
    target_joints: ["foot"],
  },
  {
    id: 165,
    title: "Om fot och fotledsbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 4,
    target_joints: ["foot"],
  },
  {
    id: 166,
    title: "Om fot och fotledsbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 3,
    target_joints: ["foot"],
  },
  {
    id: 167,
    title: "Bra att veta inför din start av programmet",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 168,
    title: "Förbered dig inför operationen",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa12-75cba00eef5e8b851096c103f43613a65794142dc459ecf180709039e2443df5.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 169,
    title: "Att hantera smärtan",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/3.handleyoursymtoms-8e516dd290615717f6089f65ef509d55a214b5343abe288d56901d17af6f97fb.svg",
    parts_count: 1,
    target_joints: ["knee", "hip"],
  },
  {
    id: 170,
    title: "Lite om höftleden och artros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 2,
    target_joints: ["hip"],
  },
  {
    id: 171,
    title: "Lite om knäleden och artros",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/4.findingyourdiagnosis-1a09888dd56c00485ba3503ce5ce3cb7e5e3138e180c15575e12c9f298a6d56c.svg",
    parts_count: 2,
    target_joints: ["knee"],
  },
  {
    id: 172,
    title: "Att tänka på inför operationen",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/2.riskfactorswithOA-f967b4f2565b217578edb9eedf81e80fa5abec3dd3e20ea1605b650735aabd8f.svg",
    parts_count: 4,
    target_joints: ["hip", "knee"],
  },
  {
    id: 173,
    title: "Inför operationsdagen och hemgång efter operationen",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/24.setbacksarecompletelynormal-dbfa89eb52f1a88d13f61f273d6c416fa5d5469fea10e73dd20c3f4f6e5cacb3.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 174,
    title: "Restriktioner och träning efter operation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa12-75cba00eef5e8b851096c103f43613a65794142dc459ecf180709039e2443df5.svg",
    parts_count: 1,
    target_joints: ["knee", "hip"],
  },
  {
    id: 175,
    title: "Minska risken för blodpropp med rörelse",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7.trainingandtheirhealtheffects-08181c2e88d3f56d65986221a61802e69992afe6456ba3e10c99180d14d85aba.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 176,
    title: "Ta hand om såret",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa06-1f3a11eba88c113700f91add3bd3500f1fda6da85e1dee931ad97c52d9ca4c57.svg",
    parts_count: 1,
    target_joints: ["knee", "hip"],
  },
  {
    id: 177,
    title: "Att hantera svullnaden",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp04.commoncausesofbackpain-93ef58d24f4c7b1fca5cf93127cf2ea3704a316593c5f79ef57ea5d04fc9d793.svg",
    parts_count: 1,
    target_joints: ["knee", "hip"],
  },
  {
    id: 178,
    title: "Smärtstillande medicin",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/8.pillstrainingandunusaltreatments-6769136321248fbf1ecc264f97d4d5980ca3ff9c430ae9e80270a07b59f552bf.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 179,
    title: "Att röra sig med en ny höftled",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
    parts_count: 1,
    target_joints: ["hip"],
  },
  {
    id: 180,
    title: "Att röra sig med en ny knäled",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp10.physicalactivitybackpain-0628e7252c03e13a4f12a8f20815966ded01093c05e05dbad15cd11e71784dbd.svg",
    parts_count: 1,
    target_joints: ["knee"],
  },
  {
    id: 181,
    title: "Idrott efter operation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/23.trainingbeforesurgery-6a9daa59eca13849017b95de395be592c0d685df92df577ad41e97554b9b991f.svg",
    parts_count: 1,
    target_joints: ["knee", "hip"],
  },
  {
    id: 182,
    title: "Samlag efter en höftledsoperation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp15.sleeppain-a42f41334523ac2497bed7d91e0f121d471d19843cd85c8aa2e6e7c1406117aa.svg",
    parts_count: 1,
    target_joints: ["hip"],
  },
  {
    id: 183,
    title: "Samlag efter en knäledsoperation",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa14-2d99206a97a2061cc446b5a5e19a973d222738af29a80f7c1febeaadb3212dde.svg",
    parts_count: 1,
    target_joints: ["knee"],
  },
  {
    id: 184,
    title: "Nutrition",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/20/whatyoushouldknowaboutsurgery-1a-1b0ebd841b109ee640f0bb35960be22c422d97f2d267e77a08ad23f81c5cdcb7.svg",
    parts_count: 1,
    target_joints: ["hip", "knee"],
  },
  {
    id: 185,
    title: "Bra att veta i början",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa001-e80e53b44ab21440e546bbab4451f30f0b89c7a3cb85cf11199c59f1623b7448.svg",
    parts_count: 4,
    target_joints: ["hand"],
  },
  {
    id: 186,
    title: "Ont i handleden",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/lbp05.lesscommoncausesofbackpain-63c996b917b1acc42ffde1111d865cebdc448b8f309cd70de54278f56034f344.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 187,
    title: "Handens och handledens anatomi",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa02-9a54f1f8270e4729e8f424af521c6baaadbbd7259fd376a6823820ccd3d297c5.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 188,
    title: "Behandling av handledssmärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/20.whatyoushowldknowaboutsurgery-4a18eb885c2ece239d106f517d20dbdb956549a8854c6f53a33693ccaae47d24.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 189,
    title: "Att lyfta saker",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa04-6c37d4e68c750146141d762a103507bf09da176ef9573214d23cc8caf55eddc5.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 190,
    title: "Att tänka på vid handledsbesvär",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_hoa03-9a6c09dbc80eeb4b8c33517bbea682ab15f12adb2467b0b7ce148526ce6e045a.svg",
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 191,
    title: "Se över ditt kontor",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/15.oatratmentandafulltimejob-92a4d4e02fd503a2b8b6f2d31f26825ed05ae0fa184893e9c955bc8600b5dffc.svg",
    parts_count: 2,
    target_joints: ["hand"],
  },
  {
    id: 192,
    title: "Handledsskydd",
    image_url: null,
    parts_count: 1,
    target_joints: ["hand"],
  },
  {
    id: 193,
    title: "Om smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/7aef948efd7eb2a1649b94f60efe77cf4af5ce2c5388157f4ae8db9e9c46b13e.svg",
    parts_count: 3,
    target_joints: ["lower_leg", "elbow", "knee", "foot", "hip", "wrist"],
  },
  {
    id: 194,
    title: "Att hantera smärta",
    image_url:
      "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/text_lesson_6-3b02504470146a82ea041ece81f8e022e447a917196e69f2ba55cfe5d8dbe32f.svg",
    parts_count: 3,
    target_joints: ["lower_leg", "elbow", "knee", "foot", "hip", "wrist"],
  },
];

export const GET_LESSON = {
  id: 91,
  name: "text_lesson_nec15",
  created_at: "2022-05-17T06:21:46Z",
  updated_at: "2022-05-17T06:21:46Z",
  target_joints: ["neck"],
  parts: [
    {
      id: 213,
      text_lesson_id: 91,
      order: 1,
      deprecated_at: null,
      created_at: "2022-05-17T06:21:46Z",
      updated_at: "2022-05-17T06:21:46Z",
      questions: '[{"order": 1, "correct_alternative": 3}]',
      translation: {
        id: 177414,
        text_lesson_part_id: 213,
        locale: "sv-se",
        title: "Andra behandlingar",
        content:
          '[{"type":"heading","content":"Vad ingår i grundbehandling av ospecifika nackbesvär? "},{"type":"paragraph","content":"FYSS är ett svenskt evidensbaserat kunskapsunderlag för rekommendation av träning och fysisk aktivitet vid olika sjukdomstillstånd och smärta. Enligt FYSS bör grundbehandlingen av nackbesvär innehålla följande: tidigt stöd av fysioterapeut, egenvård (att man får redskapen till självhjälp genom träning och fysisk aktivitet), utbildning och information.\\n\\nDenna behandling ska utgå från den enskilda personens behov. Joint Academys program följer FYSS rekommendationer för grundbehandling."},{"type":"image","content":"https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/003eab8f17b8bd42a268ea9644f9f4f58ccd7e9f4b9d59d87ef82c0c5e7b8cd6.svg"},{"type":"heading","content":"Ska jag fortsätta om jag inte blir bättre? "},{"type":"paragraph","content":"Ibland kan det bli aktuellt att lägga till andra behandlingar eller att göra ytterligare undersökningar om effekten av grundbehandlingen inte är tillräcklig. \\n\\nDet är viktigt att veta att den grundbehandling som du får i Joint Academy inte ska försvåra eventuell annan behandling. Träning har goda hälsoeffekter och bör inte försämra förutsättningarna för tilläggsbehandling. \\n\\nDiskutera gärna med din fysioterapeut på Joint Academy samt din läkare om hur olika behandlingar kan kombineras."}]',
        questions:
          '[{"title": "Vad bör grundbehandling av ospecifika nackbesvär innebära? ", "answers": [{"text": "Akupunktur.", "correct": false}, {"text": "Kirurgi.", "correct": false}, {"text": "Promenader.", "correct": false}, {"text": "Stöd av fysioterapeut, träning och utbildning.", "correct": true}], "tip_description": "Grundbehandling av nackbesvär består av stöd av fysioterapeut, träning och utbildning."}]',
        created_at: "2023-09-13T06:34:15Z",
        image_url:
          "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c9de4dee601b06233e04054950f475c2a8b8466acb6a2ce26023d733e9d212d9.svg",
      },
    },
    {
      id: 214,
      text_lesson_id: 91,
      order: 2,
      deprecated_at: null,
      created_at: "2022-05-17T06:21:46Z",
      updated_at: "2022-05-17T06:21:46Z",
      questions: '[{"order": 1, "correct_alternative": 1}]',
      translation: {
        id: 177415,
        text_lesson_part_id: 214,
        locale: "sv-se",
        title: "Andra behandlingar",
        content:
          '[{"type":"heading","content":"Smärtlindrande mediciner vid nackbesvär"},{"type":"paragraph","content":"Vårdguiden 1177 rekommenderar smärtstillande receptfria läkemedel med paracetamol samt antiinflammatoriska läkemedel vid smärta i nacken.\\n\\nDet kan dock vara viktigt att veta att så kallade antiinflammatoriska läkemedel (exempelvis Ipren och Naproxen) medför risk för biverkningar, framförallt vid långvarigt bruk och enligt Socialstyrelsen inte bör användas av personer äldre än 75 år. "},{"type":"image","content":"https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/59e313016333e41902e90aac35c80adc1aef68dacfb67b7800102f25275f9074.svg"},{"type":"heading","content":"Möjliga biverkningar "},{"type":"paragraph","content":"Antiinflammatoriska läkemedel ökar bland annat risken för hjärt-kärlsjukdomar liksom magsår, särskilt för äldre personer. Använd dessa former av läkemedel med försiktighet och diskutera med din läkare om och när det är lämpligt.\\n\\nFör vissa individer kan smärtstillande behövas för att kunna röra sig vissa dagar, genomföra ett träningspass eller få tillräcklig sömn. Att använda dem under begränsade perioder och omfattning minskar risken för biverkning."}]',
        questions:
          '[{"title": "Vad stämmer för vanliga antiinflammatoriska läkemedel exempelvis Ipren? ", "answers": [{"text": "De ökar risken för huvudvärk. ", "correct": false}, {"text": "Biverkningar kan vara ökad risk för hjärt -kärlsjukdomar samt magsår och de bör inte användas av personer äldre än 75 år. ", "correct": true}, {"text": "De är beroendeframkallande. ", "correct": false}, {"text": "De innehåller inga verksamma substanser. ", "correct": false}], "tip_description": "Antiinflammatoriska läkemedel kan ha en viss effekt för att lindra tillfällig smärta i nacken men de kan också öka risken för bland annat hjärt-kärlsjukdomar samt magsår. De ska därför användas med omdöme och försiktighet."}]',
        created_at: "2023-09-13T06:34:15Z",
        image_url:
          "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c9de4dee601b06233e04054950f475c2a8b8466acb6a2ce26023d733e9d212d9.svg",
      },
    },
    {
      id: 215,
      text_lesson_id: 91,
      order: 3,
      deprecated_at: null,
      created_at: "2022-05-17T06:21:46Z",
      updated_at: "2022-05-17T06:21:46Z",
      questions: '[{"order": 1, "correct_alternative": 3}]',
      translation: {
        id: 177416,
        text_lesson_part_id: 215,
        locale: "sv-se",
        title: "Andra behandlingar",
        content:
          '[{"type":"heading","content":"Kan injektioner hjälpa vid nackbesvär? "},{"type":"paragraph","content":"Det saknas idag tillräcklig vetenskaplig evidens för att veta om injektioner med kortison har en god effekt vid ospecifik nacksmärta. \\n \\nDe biverkningar man känner till är förändringar på vävnaden man sprutar in i, då kortison har en nedbrytande effekt."},{"type":"image","content":"https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/a058435034d90f71c3ba7e98414c9afee38e837bb4bdcb9a0198443ad6c940bf.svg"},{"type":"heading","content":"Kan manipulation, mobilisering och akupunktur hjälpa vid nackbesvär? "},{"type":"paragraph","content":"När det gäller behandlingar som akupunktur, manipulation och mobilisering, massage, elektroterapi och yoga så kan dessa ha en viss effekt för att minska ospecifik nacksmärta.\\n\\nDäremot finns det hittills inga övertygande bevis på att traktion (behandling där lederna separeras lätt genom att ryggraden sträcks ut), kyla och värme, och specialkuddar har någon effekt på nacksmärta. "}]',
        questions:
          '[{"title": "Vilken av nedanstående behandlingar har starkast evidens vid nackbesvär? ", "answers": [{"text": "Massage.", "correct": false}, {"text": "Injektioner med kortison i nacken. ", "correct": false}, {"text": "Elektroterapi.", "correct": false}, {"text": "Handledd träning och råd från fysioterapeut.", "correct": true}], "tip_description": "Det finns flertalet vanligt förekommande behandlingsmetoder för de med nackbesvär som lever kvar trots att bevisen för deras effekt, utöver den man kan förvänta sig av placebo, är tveksam eller okänd. Dock finns viss evidens för fysioterapeut-handledd träning."}]',
        created_at: "2023-09-13T06:34:15Z",
        image_url:
          "https://d19ql778rv9cdq.cloudfront.net/content_images/text_lessons/cover_images/c9de4dee601b06233e04054950f475c2a8b8466acb6a2ce26023d733e9d212d9.svg",
      },
    },
  ],
};
